export const FEEDBACK_SURFACES = [
   'workbench',
   'guide-edit',
   'wiki-edit',
   'guide-translate',
   'wiki-translate',
   'moderate',
] as const;

export type FeedbackSurface = (typeof FEEDBACK_SURFACES)[number];

export function isFeedbackSurface(value: unknown): value is FeedbackSurface {
   return typeof value === 'string' && (FEEDBACK_SURFACES as readonly string[]).includes(value);
}
